<script setup>
import { useI18n } from 'vue-i18n';
import { commissionSectionLabel } from '../composables/salesCommissionParticipantLabels';

const props = defineProps({
  active: { type: String, required: true },
  available: { type: Array, default: () => [] },
  completed: { type: Array, default: () => [] },
  sections: { type: Array, default: () => [] },
});

const emit = defineEmits(['select']);
const { t } = useI18n();
const label = section => commissionSectionLabel(t, section);
const isAvailable = section => props.available.includes(section);
const isComplete = section => props.completed.includes(section);
</script>

<template>
  <nav
    class="flex gap-2 overflow-x-auto rounded-lais border border-lais-border-soft bg-white p-2 lg:block lg:space-y-2 lg:overflow-visible"
    :aria-label="t('SALES.COMMISSION.ARIA.NAVIGATION')"
  >
    <button
      v-for="section in sections"
      :key="section"
      type="button"
      :disabled="!isAvailable(section)"
      :aria-current="active === section ? 'step' : undefined"
      class="flex min-w-max items-center gap-3 rounded-lais px-3 py-3 text-left text-sm font-semibold transition disabled:cursor-not-allowed lg:w-full"
      :class="
        active === section
          ? 'bg-lais-primary-50 text-lais-primary'
          : isComplete(section)
            ? 'text-lais-text hover:bg-lais-bg-soft'
            : 'text-lais-text-muted disabled:text-lais-text-disabled'
      "
      @click="emit('select', section)"
    >
      <span
        class="grid size-7 place-items-center rounded-full"
        :class="
          active === section || isComplete(section)
            ? 'bg-lais-primary-50 text-lais-primary'
            : 'bg-lais-bg-soft text-lais-text-disabled'
        "
      >
        <span
          :class="
            isComplete(section) && active !== section
              ? 'i-lucide-check'
              : 'i-lucide-pencil'
          "
          class="size-4"
          aria-hidden="true"
        />
      </span>
      <span>{{ label(section) }}</span>
    </button>
  </nav>
</template>
